export default __webpack_public_path__ + "static/media/single-corded.5d84d5dc.webp";